













































































































import Vue, { PropType } from 'vue';
import * as tools from '@/modules/tools';
// import { ItemData } from '@/modules/exhibitor/item';
// import { Story } from '@/modules/exhibitor/story';
// import { Option } from 'mostra';

import {
  Option,
  Story,
  // Item,
  story,
  options,
} from 'mostra';

// import { Option, storyOptions } from '@/modules/options';
import { v4 } from 'uuid';
// import GInputLabel from './GInputLabel.vue';
// import GImageDescriptionForm from './GImageDescriptionForm.vue';
// import GImageDescriptionForm from './GImageDescriptionForm.vue';

const {
  createStoryTitle,
  createStoryDescription,
  createStoryImage,
  createStoryVideo,
  createStoryImageDescription,
  createStoryGallery,
} = story;

const generateListKey = () => v4();

type StoryItem = {
  id: string,
  story: Story,
}

export type DataType = {
  storyOptions: Option;
  // carouselType: Option;
  displayType: Number;
  // designDisplayTypes: Option;
  storyImageDescriptionTitle: String,
};

export default Vue.extend({
  // components: { GImageDescriptionForm },
  // components: { GImageDescriptionForm },
  // components: { GInputLabel },
  name: 'GStoryForm',
  props: {
    owner: {
      type: String as PropType<string>,
      required: true,
    },
    stories: {
      type: Array as PropType<Story[]>,
      default: () => ([]),
    },
    // item: {
    //   type: Object as PropType<Item>,
    //   required: true,
    // },
    // addNewStory: {
    //   type: Function as PropType<Function>,
    //   default: () => false,
    // },
    // onDelete: {
    //   type: Function as PropType<Function>,
    // },
    // onUp: {
    //   type: Function as PropType<Function>,
    // },
    // onDown: {
    //   type: Function as PropType<Function>,
    // },
  },
  data(): DataType {
    return {
      storyOptions: options.storyOptions,
      // storyOptions: [
      //   { value: 1, text: '見出し' },
      //   { value: 2, text: '説明文' },
      //   { value: 3, text: '画像' },
      //   { value: 4, text: '動画(YouTube)' },
      //   { value: 5, text: '商品＋文章' },
      // ],
      // carouselType: options.carouselType,
      displayType: 1,
      // designDisplayTypes: options.storyImageDescriptionTypes,
      storyImageDescriptionTitle: '',
    };
  },
  computed: {
    innerStories(): StoryItem[] {
      return this.stories.map((st: Story) => (
        {
          id: generateListKey(),
          story: st,
        }
      ));
    },
  },
  methods: {
    addNewStory(val: number): void {
      switch (val) {
        case 1:
          this.stories.push(createStoryTitle());
          break;
        case 2:
          this.stories.push(createStoryDescription());
          break;
        case 3:
          this.stories.push(createStoryImage());
          break;
        case 4:
          this.stories.push(createStoryVideo());
          break;
        case 5:
          this.stories.push(createStoryImageDescription());
          break;
        case 6:
          this.stories.push(createStoryGallery());
          break;
        default:
      }
    },
    onDeleteStory(list: Story[], index: number) {
      tools.deleteList(list, index);
      // this.onDelete(list, index);
    },
    onUpStory(list: Story[], index: number) {
      // this.onUp(list, index);
      tools.upList(list, index);
    },
    onDownStory(list: Story[], index: number) {
      tools.downList(list, index);
      // this.onDown(list, index);
    },
  },
});
